import GetUserBasicInfoDocument from "src/api/graphql/__generated__/documents/GetUserBasicInfoDocument";
import FaceFilterMode from "src/api/graphql/__generated__/enums/FaceFilterMode";
import PillButton from "src/components/PillButton";
import ProfilePicture from "src/components/ProfilePicture";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { useClientId } from "src/helpers/globalHelpers";
import useRevalidatedQuery from "src/hooks/useRevalidatedQuery";
import IconAll from "src/icons/IconAll";
import IconClose from "src/icons/IconClose";
import IconTogether from "src/icons/IconTogether";
import { paddingMedium } from "src/styles/spacing";
import { PillProps } from "src/swsh-native/Pill";

const FilterDisplayPill = ({
	children,
	Icon,
	CustomIcon,
}: Pick<PillProps, "children" | "Icon" | "CustomIcon">) => {
	const resetFaceFilters = useGatheringStore((state) => state.resetFaceFilters);
	return (
		<PillButton
			Icon={Icon}
			CustomIcon={CustomIcon}
			ActionIcon={IconClose}
			onPress={resetFaceFilters}
			blur
		>
			{children}
		</PillButton>
	);
};

const FilterDisplayUser = ({ userId }: { userId: string }) => {
	const { data, loading } = useRevalidatedQuery(GetUserBasicInfoDocument, {
		variables: {
			input: {
				userId,
			},
		},
		skip: !userId,
	});

	if (loading) return null;
	return (
		<FilterDisplayPill
			CustomIcon={
				<ProfilePicture userId={userId} size={26} style={{ marginLeft: paddingMedium }} />
			}
		>
			{data?.getUserBasicInfo?.firstName ?? undefined}
		</FilterDisplayPill>
	);
};

const FilterDisplayContent = () => {
	const filterMode = useGatheringStore((state) => state.filterMode);
	const filterUserIds = useGatheringStore((state) => state.filterUserIds);

	if (filterUserIds.length === 1) {
		const userId = filterUserIds[0];
		if (!userId) return null;
		return <FilterDisplayUser userId={userId} />;
	}
	switch (filterMode ?? FaceFilterMode.Or) {
		case FaceFilterMode.And:
			return <FilterDisplayPill Icon={IconTogether}>Together</FilterDisplayPill>;
		case FaceFilterMode.Or:
			return <FilterDisplayPill Icon={IconAll}>All</FilterDisplayPill>;
		default:
			return null;
	}
};

const FilterDisplay = () => {
	const clientId = useClientId();
	const hasOtherPeopleFiltered = useGatheringStore(
		(state) =>
			state.filterUserIds.length > 0 &&
			(state.filterUserIds.length > 1 || state.filterUserIds[0] !== clientId),
	);
	if (!hasOtherPeopleFiltered) return null;
	return <FilterDisplayContent />;
};
export default FilterDisplay;
